import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

import { adminUpdateProfile } from '../../../services/admin.service';
import TeacherForm from '../../../components/teacher/forms/TeacherForm';
import * as teacherService from '../../../services/teacher.service';
import { mapProfileToTeacher } from '../../../utils/teacherMapper';

export default function EditTeacher() {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const res = await teacherService.getProfileById(id);

        if (res.data) {
          setInitialData(mapProfileToTeacher(res.data));
        } else {
          navigate('/admin/teachers');
        }
      } catch (err) {
        setLoadError(true);
      }
    };

    loadProfile();
  }, [id, navigate]);

  if (loadError) {
    return (
      <div className="p-6 flex flex-col items-center justify-center min-h-[400px] gap-4">
        <p className="text-red-400 text-lg">Failed to load teacher profiel</p>
      </div>
    );
  }

  if (!initialData) {
    return (
      <div className="flex items-center justify-center h-64">
        <CircularProgress sx={{ color: '#F6911D' }} />
      </div>
    );
  }

  return (
    <TeacherForm
      mode="edit"
      initialData={initialData}
      onSubmit={(payload) => adminUpdateProfile(id, payload)}
    />
  );
}
